import { TransportDetailsModule } from './../../common/components/transport-details/transport-details.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTabletTransportModule } from './action-tablet-transport/action-tablet-transport.module';
import { ActionTabletRefusedLeaveComponent } from './action-tablet-refused-leave/action-tablet-refused-leave.component';
import { ActionTabletModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonUIElementsModule } from '@sdbn/common';



@NgModule({
  declarations: [
    ActionTabletRefusedLeaveComponent
  ],
  imports: [
    CommonModule,
    ActionTabletTransportModule,
    ActionTabletModule,
    CommonLayoutModule,
    TransportDetailsModule,
    CommonUIElementsModule
  ]
})
export class ControlModule { }
